import { render, staticRenderFns } from "./CustomError.vue?vue&type=template&id=40d24bb2&scoped=true"
import script from "./CustomError.vue?vue&type=script&lang=js"
export * from "./CustomError.vue?vue&type=script&lang=js"
import style0 from "./CustomError.vue?vue&type=style&index=0&id=40d24bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d24bb2",
  null
  
)

export default component.exports